import { useTranslations } from 'next-intl';

export default function CardSymbolism({ symbolism, className = '', textClassName = '', variant = 'default', renderArt }) {
  const t = useTranslations('tarot.card');

  const containerClasses =
    variant === 'sidebar'
      ? `rounded-2xl border border-[#6A3683]/30 bg-[#120f27]/70 px-5 py-6 shadow-lg shadow-[#6A3683]/10 ${className}`
      : `my-8 ${className}`;

  const bodyClasses =
    variant === 'sidebar'
      ? `text-sm leading-relaxed text-[#E6DAFF]/90 ${textClassName}`
      : `text-gray-300 text-lg leading-relaxed ${textClassName}`;

  return (
    <div className={containerClasses}>
      <div className="flex justify-center">
        <h2 className="tracking-[0.35em] text-[#D4B6FF]/80 text-xs uppercase mb-3 text-center" style={{ fontFamily: "var(--font-marcellus)" }}>
          {t('symbolism')}
        </h2>
      </div>
      {renderArt ? <div className="mb-5">{renderArt()}</div> : null}
      <p className={bodyClasses}>{symbolism}</p>
    </div>
  );
}